import React from "react";
import LocalOfferIcon from "@mui/icons-material/LocalOfferOutlined";

const Topics: React.FunctionComponent<ComponentProps> = ({
    topics, 
    topicLabel, 
    className, 
    iconClassName, 
    iconSize = "inherit", 
    useTopicsIcon}
) => {

  if (!topics || topics.length === 0) {
    return (null);
  }

  return <div className={className ?? "topics"}>
    {
      !!topicLabel || useTopicsIcon 
        ? topicLabel 
        : <LocalOfferIcon fontSize={iconSize} className={iconClassName}/>
    }
    {topics.map(topic => topic.name).join(", ")}
  </div>;
};

interface ComponentProps {
  topics: { id: string, name: string }[];
  topicLabel?: string;
  className?: string;
  iconSize?: "small" | "inherit";
  iconClassName?: string;
  useTopicsIcon?: boolean;
}

export default Topics;